import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import AutoPlay from "./AutoPlay";

export default function TrainingCard({ title }) {
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);
  // const [activeTab, setActiveTab] = useState("training");

  // const settings = {
  //   dots: true,
  //   infinite: true,
  //   slidesToShow: 4,
  //   slidesToScroll: 1,
  //   autoplay: true,
  //   // speed: 2000,
  //   autoplaySpeed: 5000,
  //    responsive: [
  //     {
  //       breakpoint: 992,
  //       settings: {
  //         slidesToShow: 3,
  //         slidesToScroll: 1,
  //       }
  //     },
  //     {
  //       breakpoint: 768,
  //       settings: {
  //         slidesToShow: 2,
  //         slidesToScroll: 1,
  //       }
  //     },
  //     {
  //       breakpoint: 575,
  //       settings: {
  //         slidesToShow: 1,
  //         slidesToScroll: 1,
  //       }
  //     }
  //   ]
  //   // cssEase: "linear"
  // };

  useEffect(() => {
    let isMounted = true;
    const controller = new AbortController();
    
    axios
      .get(constvar.api_url + "trainings/frontend-list", { signal: controller.signal })
      .then((res) => {
        if (!isMounted) return;
        if (res.data.status === "success") setPrograms(res.data.data || []);
      })
      .catch(error => {
        if (!isMounted) return;
        if (error.name !== "AbortError" && error.name !== "CanceledError") {
          console.error("Failed to load training programs:", error);
          setPrograms([]);
        }
      })
      .finally(() => setLoading(false));

    // Cleanup: cancel request if component unmounts
    return () => {
      isMounted = false;
      controller.abort();
    };
  }, []);

      const getBreakpointSettings = (maxSlidesForScreen) => {
    // 1. Cap it at the maximum allowed for this screen size or total jobs
    let computedSlides = Math.min(programs.length, maxSlidesForScreen) || 1;

    // 2. Apply your forced-scroll deduction rule
    if (programs.length > 1 && programs.length <= maxSlidesForScreen) {
      computedSlides = programs.length - 1;
    }

    const shouldScroll = programs.length > computedSlides;

    return {
      slidesToShow: computedSlides,
      infinite: shouldScroll,
      autoplay: shouldScroll,
    };
  };

  // Base settings for desktop (Max 5 slides)
  const desktopSettings = getBreakpointSettings(5);

  const settings = {
    dots: true,
    arrows: false,
    slidesToScroll: 1,
    autoplaySpeed: 5000,
    
    // Spread desktop calculations
    slidesToShow: desktopSettings.slidesToShow,
    infinite: desktopSettings.infinite,
    autoplay: desktopSettings.autoplay,

    responsive: [
      {
        breakpoint: 992, // Tablets/Small Laptops (Max 3 slides)
        settings: {
          ...getBreakpointSettings(3),
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 768, // Small Tablets (Max 2 slides)
        settings: {
          ...getBreakpointSettings(2),
          slidesToScroll: 1,
        }
      },
      {
        breakpoint: 575, // Mobile Phones (Max 1 slide)
        settings: {
          ...getBreakpointSettings(1),
          slidesToScroll: 1,
        }
      }
    ]
  };

  if (!loading && programs.length === 0) return null;

  return (
    <section className="sf-section bg-white training-list-sec">
      <div className="sf-container">
        <div className="sf-section-header">
          <h2 className="sf-section-title ml-auto mr-auto">{title || "Explore Our Training"}</h2>
        </div>

        {/* <div className="sf-training-tabs">
          <div
            className={"sf-tab" + (activeTab === "training" ? " active" : "")}
            onClick={() => setActiveTab("training")}
          >
            Training Jobs
          </div>
          <div
            className={"sf-tab" + (activeTab === "upcoming" ? " active" : "")}
            onClick={() => setActiveTab("upcoming")}
          >
            Upcoming Training
          </div>
        </div> */}

        {loading ? (
          <div className="sf-loading">
            <i className="fa fa-spinner fa-spin" /> Loading…
          </div> 
        ) : (
          <AutoPlay settings={settings}>
            {programs.map((prog, idx) => (
              <div key={prog.id || idx} className="sf-training-card">
                <div className="sf-training-img">
                  <img
                    src={`/uploads/trainings/${prog.banner_image || "/default/default_banner.jpg"}`}
                    alt={prog.title}
                    onError={(e) => { e.target.src = "/default/default_banner.jpg"; }}
                  />
                </div>
                <div className="sf-training-body">
                  <div className="sf-training-title">{prog.title}</div>
                    <div className="sf-training-meta">
                      {prog.duration && (
                        <span>
                          <i className="fa fa-clock-o" /> {prog.duration}
                        </span>
                      )}
                      {/* {prog.level && (
                        <span style={{ marginLeft: 10 }}>
                          <i className="fa fa-signal" /> {prog.level}
                        </span>
                      )} */}
                    </div>

                  <div className="sf-training-btns">
                    <Link to={`/training${prog.slug && '/' + prog.slug}`} className="sf-btn sf-btn-info">
                      Learn More
                    </Link>
                    <Link to="/contact-us" className="sf-btn sf-btn-primary">
                      Enroll Now
                    </Link>
                  </div>
                </div>
              </div>
            ))}
          </AutoPlay>
        )}
        
      </div>
    </section>
  );
}
